export default __webpack_public_path__ + "static/media/meat-hawaiian.7eaf871b.jpg";